import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

const createAnnouncement = async (announcementData) => {
  try {
    const token = getAuthToken();

    const data = await api.post("/announcements", announcementData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

// const sendAnnouncement = async (id, announcementData) => {
//   try {
//     const token = getAuthToken();
//     const data = await api.post(`/announcements/${id}/send`, announcementData, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return data.data;
//   } catch (err) {
//     throw err;
//   }
// };

const updateAnnouncement = async (id, announcementData) => {
  try {
    const token = getAuthToken();
    const data = await api.put(`/announcements/${id}`, announcementData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const removeAnnouncement = async (id) => {
  try {
    const token = getAuthToken();
    await api.delete(`/announcements/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (err) {
    throw err;
  }
};

const getAnnouncements = async () => {
  try {
    const token = getAuthToken();
    const data = await api.get("/announcements", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

export {
  createAnnouncement,
  //   sendAnnouncement,
  updateAnnouncement,
  removeAnnouncement,
  getAnnouncements,
};
